import React, { useState } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template126: Tiendas originales en Londres (Shops.jsx guia-londres). Todo desde backend.
// page.texts[0]=header, [1]=intro, [2]=closingText | page.shops, page.images
const Template126 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found) return found.src ?? found.url;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const logoImage = page.canvasImages?.find(
		(img) => img.id === "logo",
	)?.imageUrl;
	const introText = page?.texts?.[1]?.content;
	const closingText = page?.texts?.[2]?.content;
	const shops = Array.isArray(page?.shops)
		? page.shops
		: Array.isArray(page?.data?.shops)
			? page.data.shops
			: Array.isArray(page?.data?.data?.shops)
				? page.data.data.shops
				: [];
	const shopSticker =
		getImageSrc("fao-stickers") || getCanvasImageUrl("shop-sticker");
	const hamleysSticker =
		getImageSrc("hamleys-sticker") || getCanvasImageUrl("hamleys-sticker");
	const [shopStickerError, setShopStickerError] = useState(false);
	const [hamleysStickerError, setHamleysStickerError] = useState(false);

	const actualHeaderColor = headerBackgroundColor || "#de5624";
	const contentColor = textColor || "#444";

	const h4 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		fontWeight: 600,
		margin: "6px 0 4px",
		textAlign: "center",
	};
	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: isSmallScreen ? 66 : 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "16px", fontSize: 13, color: contentColor }}>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}

			{shops.length > 0 && (
				<Box
					data-block-id="text-2"
					sx={{
						padding: "0 12px 12px",
						display: "flex",
						flexWrap: "wrap",
						gap: "12px",
						position: "relative",
						justifyContent: "center",
					}}
				>
					{shops.map((shop) => {
						const src = getImageSrc(shop.imageId);
						return (
							<Box
								key={shop.name}
								sx={{
									backgroundColor: "#fff",
									borderRadius: "12px",
									width: isSmallScreen ? "30%" : "30%",
									padding: "8px",
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
								}}
							>
								{src && (
									<img
										src={src}
										alt={shop.name}
										style={{
											width: "100%",
											height: 70,
											objectFit: "cover",
											borderRadius: 8,
										}}
									/>
								)}
								<Box component="h4" sx={{ ...h4, textAlign: "left" }}>
									{shop.name}
								</Box>
								{shop.address && (
									<Box component="p" sx={{ ...p, textAlign: "left" }}>
										{shop.address}
									</Box>
								)}
							</Box>
						);
					})}
					{shopSticker && !shopStickerError && (
						<img
							src={shopSticker}
							alt=""
							onError={() => setShopStickerError(true)}
							style={{
								width: 110,
								position: "absolute",
								bottom: isSmallScreen ? -90 : -55,
								left: -30,
							}}
						/>
					)}
					{hamleysSticker && !hamleysStickerError && (
						<img
							src={hamleysSticker}
							alt=""
							onError={() => setHamleysStickerError(true)}
							style={{
								width: 110,
								position: "absolute",
								bottom: isSmallScreen ? -90 : -55,
								right: -30,
							}}
						/>
					)}
				</Box>
			)}

			{closingText && (
				<Box
					data-block-id="text-3"
					sx={{
						padding: "0 16px 20px",
						textAlign: "center",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Box
						sx={{
							fontSize: 13,
							color: contentColor,
							margin: 0,
							maxWidth: isSmallScreen ? 200 : 380,
						}}
					>
						<Box
							component="span"
							dangerouslySetInnerHTML={{ __html: closingText }}
						/>
					</Box>
				</Box>
			)}
		</Box>
	);
};

Template126.thumbnail = "/images/template-1.png";

export default Template126;
